module.exports = __webpack_public_path__ + "static/img/icon_drawer.a619255c.png";